<template>
  <div>
    <div v-if="showVisible" style="height: 50px">
      <nav class="mobile-nav" :style="productTopNavBg">
        <div class="nav-left">
          <div
            class="sidebar-btn black-color nav-left-item"
            style="height: 22px"
            @click="handleOpenD123()"
          >
            <img src="@/assets/images/login/d123.png" style="width: 22px; height: 22px" alt="" />
          </div>
          <div class="sidebar-btn black-color nav-left-item" @click="switchSidebar">
            <i class="el-icon-time"></i>
          </div>
        </div>
        <div class="nav-center">
          <div class="nav-center-item">
            <div>{{ $t("mobileNav.title") }}</div>
          </div>
        </div>
        <div class="nav-right">
          <div class="sidebar-btn black-color nav-right-item" @click="handleNewChat('title')">
            <i class="el-icon-circle-plus-outline"></i>
          </div>
          <div class="sidebar-btn black-color nav-right-item" @click="handleLogin">
            <div style="position: relative; cursor: pointer">
              <img
                v-if="vipType"
                class="vip-head-ranking"
                src="@/assets/images/login/vip-head.png"
              />
              <el-avatar v-if="headImagePath" :size="20" :src="headImagePath" @error="true">
                <img
                  style="width: 100%; height: 100%"
                  :src="require('@/assets/images/head_img.png')"
                />
              </el-avatar>
              <el-avatar v-else :size="20" :src="require('@/assets/images/head_img.png')" />
            </div>
          </div>
        </div>
      </nav>
      <mobile-sidebar
        :show-visible="sidebarActive"
        :session-history-list="sessionHistoryList"
        @callback="switchSidebar"
        @newChat="handleNewChat"
        @getHistory="handleGetHistory"
      />
    </div>
  </div>
</template>

<script>
import MobileSidebar from "./MobileSidebar";

export default {
  components: { MobileSidebar },
  props: {
    showVisible: {
      type: Boolean,
      default() {
        return true;
      },
    },
    sessionHistoryList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      sidebarActive: false,
      nodesActive: false,
      navbarActive: false,
      productTopNavBg: {
        backgroundColor: "",
        boxShadow: "none",
      },
    };
  },
  computed: {
    isLogin() {
      return this.$store.state.user.userId != null;
    },
    headImagePath() {
      return this.$store.state.user.headImagePath;
    },
    vipType() {
      return this.$store.state.user.vipType;
    },
  },

  mounted() {
    // 监听页面滚动
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // 滚动之前重置
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleLogin() {
      window.location.href = process.env.VUE_APP_D123_URL + "/?op=dxxLogin";
    },
    handleOpenD123() {
      window.location.href = process.env.VUE_APP_D123_URL;
    },
    handleNewChat(val) {
      this.$emit("newChat");
      if (!val) {
        this.switchSidebar();
      }
    },
    async handleGetHistory(sessionId) {
      this.$emit("getHistory", sessionId);
      this.switchSidebar();
    },
    handleScroll() {
      // 滚动页面时触发导航变色
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // 设置背景颜色的透明度
      if (scrollTop) {
        // scrollTop + 多少根据自己的需求设置
        this.productTopNavBg = {
          backgroundColor: "#F6F8FA",
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.35)",
        };
      } else if (scrollTop === 0) {
        // 设置回到顶部时，背景颜色为透明
        this.productTopNavBg = {
          backgroundColor: "transparent",
          boxShadow: "none",
        };
      }
    },
    switchSidebar() {
      this.sidebarActive = !this.sidebarActive;
    },
  },
};
</script>
<style lang="scss" scoped>
$navZIndex: 30;
$sidebarZIndex: 50;

.vip-head-ranking {
  cursor: pointer;
  position: absolute;
  transform: rotate(20deg);
  top: -4px;
  right: -5px;
  width: 10px;
  height: 10px;
}

.mobile-nav {
  position: fixed;
  height: 50px;
  top: 0;
  right: 0;
  left: 0;
  box-shadow: 0 2px 0 0 var(--border-color);
  padding: 0 16px;
}

.mobile-nav {
  z-index: $navZIndex;
  background-color: #f6f8fa;
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > div {
    display: flex;
    align-items: center;
  }

  .nav-left {
    .logo_img {
      width: 60px;
      max-height: 16px;
    }
    .sidebar-btn {
      margin-top: 0px;
      i {
        color: #fff;
        font-size: 22px;
      }
    }
    .nav-left-item {
      margin-right: 10px;
      &:last-child {
        margin-right: 0px;
      }
    }
    .sidebar-btn.white-color {
      i {
        color: #fff;
      }
    }
    .sidebar-btn.black-color {
      i {
        color: #000;
      }
    }
  }

  .nav-center {
    display: flex;
    .nav-center-item {
      width: 100%;
      margin: 0px 0px;
    }
    .menu-item {
      font-size: 12px;
      color: var(--text-color);
      font-weight: 500;
      letter-spacing: 0;
      text-align: left;
      display: flex;
      align-items: center;
      cursor: pointer;
      user-select: none;

      a {
        color: var(--text-color);
      }

      .iconfont {
        font-size: 20px !important;
        margin-left: -2px;
      }

      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  .nav-right {
    height: 100%;
    align-items: center;
    .nav-right-item {
      margin-right: 10px;
      font-size: 0px;
      &:last-child {
        margin-right: 0px;
      }
      i {
        color: #000;
        font-size: 20px;
      }
      .lang-select {
        position: fixed;
        top: 33px;
        right: 10px;
        z-index: 2001;
        width: 90px;
        padding: 10px 0;
        margin: 5px 0;
        background-color: #fff;
        border: 1px solid #ebeef5;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        div {
          line-height: 36px;
          padding: 0 20px;
          margin: 0;
          font-size: 14px;
          color: #606266;
          cursor: pointer;
        }
      }
    }
    .language_div {
      margin-right: 10px;
      i {
        color: #fff;
        font-size: 20px;
      }
    }
    .language_div.white-color {
      i {
        color: #fff;
      }
    }
    .language_div.black-color {
      i {
        color: #000;
      }
    }
    .sidebar-btn {
      margin-top: 0px;
      i {
        color: #fff;
        font-size: 22px;
      }
    }
    .sidebar-btn.white-color {
      i {
        color: #fff;
      }
    }
    .sidebar-btn.black-color {
      i {
        color: #000;
      }
    }

    width: max-content;
    //cursor: pointer;

    .create-topic-btn {
      display: flex;
      align-items: center;
      padding-right: 4px;
    }
  }
}
</style>
